import Vue from 'vue'
import Pusher from 'pusher-js'
import Echo from 'laravel-echo'
import { http } from '@/utils'

Pusher.logToConsole = process.env.VUE_APP_PUSHER_LOG || false
window.Pusher = Pusher

const options = {
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_KEY,
  authorizer (channel, options) {
    return {
      authorize (socket, callback) {
        http.post(process.env.VUE_APP_PUSHER_ENDPOINT, { 'socket_id': socket, 'channel_name': channel.name })
          .then((response) => {
            callback(null, response.data)
          })
          .catch(callback)
      }
    }
  },
  namespace: 'LHD.Events',
  cluster: process.env.VUE_APP_PUSHER_CLUSTER
}

const VueEcho = {
  install (Vue, options) {
    if (!options) {
      throw new Error('[Vue-Echo] cannot locate options')
    }

    if (typeof options !== 'object') {
      throw new Error('[Vue-Echo] cannot initiate options')
    }

    Vue.prototype.$echo = new Echo(options)

    Vue.mixin({
      mounted () {
        this.$nextTick(() => {
          let channel = this.$options.channel

          if (typeof channel === 'function') {
            channel = channel(this)
            if (channel.startsWith('private:')) {
              this.channel = this.$echo.private(channel.replace('private:', ''))
            } else if (channel.startsWith('presence:')) {
              this.channel = this.$echo.join(channel.replace('presence:', ''))
            } else {
              this.channel = this.$echo.channel(channel)
            }

            if (typeof this.$options['channelSubscribed'] === 'function') {
              this.channel.subscribed(() => this.$options['channelSubscribed'](this.channel, this))
            }

            let events = this.$options['echo']

            if (events) {
              Object.keys(events).forEach(function (key) {
                let method = key.startsWith('whisper:') ? 'listenForWhisper' : 'listen'

                // Bind the VM as second parameter
                this.channel[method](key.replace('whisper:', ''), (payload) => {
                  events[key](payload, this)
                })
              }, this)
            }
          }
        })
      },
      beforeDestroy () {
        if (this.channel) {
          this.$echo.leaveChannel(this.channel.name)
        }
      }
    })
  }
}

Vue.use(VueEcho, options)
